export class EmailReturnLabelDto {
    recipientEmail: string;
}